import Card from "./components/Card";

export { Card };

export default Card;
